import { createContext, useContext } from 'react';
import { CustomerProfile } from '../models/customerProfile';

const LIFFUserContext = createContext<CustomerProfile | undefined>(undefined);
export const useLIFFUser: () => CustomerProfile | undefined = () =>
  useContext(LIFFUserContext);

export default LIFFUserContext;
